import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_ClinicalAssessmentSignaturePage = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_ClinicalAssessmentSignaturePage' className='file-pdf-document'>
            <div className='file-template'>
            <p><h3>CLINICAL ASSESSMENT SIGNATURE PAGE</h3></p>
            <p><h4>I. Person Responsible For The Comprehensive Clinical Assessment:</h4></p>
                <p>
                    <input type="checkbox" id="cbClinicalAssessment" name="cbClinicalAssessment" className='add-only' value="1" />
                    Confirm responsibility for the development of this Comprehensive Clinical Assessment
                </p>
                <table>
                    <tr>
                        <td className='signature w-350'>
                        </td>
                        <td className='signature w-250'>
                        </td>
                        <td className='signature w-150'>
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-350">Signature (with credentials)
                        </td>
                        <td className="small w-250">Print Name:
                        </td>
                        <td className="small w-150">Date:
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3>II. Additional Participants</h3></p>
                <table>
                    <tr>
                        <td className='signature w-350'>
                        </td>
                        <td className='signature w-250'>
                        </td>
                        <td className='signature w-150'>
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-350'>Signature (with credentials)
                        </td>
                        <td className='small w-250'>Print Name:
                        </td>
                        <td className='small w-150'>Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-350'>
                        </td>
                        <td className='signature w-250'>
                        </td>
                        <td className='signature w-150'>
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-350'>Signature (with credentials)
                        </td>
                        <td className='small w-250'>Print Name:
                        </td>
                        <td className='small w-150'>Date:
                        </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
